module.exports = __webpack_public_path__ + "static/media/telegram.82e3c099.svg";